import { Avatar, Col, Row } from "antd";
import { PaymentComponentProps } from "./Item";
import { RightOutlined } from "@ant-design/icons";
import dayjs from "../../../../../configs/dayjs";
import { useGetIcon } from "../../hooks/useGetIcon";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";

export const OneTimePayment = ({ values }: PaymentComponentProps) => {
  const { getIcon } = useGetIcon();

  return (
    <>
      <Col span={4}>
        <Row className="align-center avatar">
          <Avatar
            icon={getIcon("OneTimePayment")}
            size={40}
            className="option d-flex justify-center"
          />
        </Row>
      </Col>

      <Col span={12}>
        <Row className="d-block h-100 align-content-center item-title">
          <p className="my-0 text-md w-500">One-Time Payment</p>
        </Row>
      </Col>

      <Col span={6}>
        <Row className="d-block h-100 text-align-end item-amount">
          <p className="my-0 text-md w-500 text-no-wrap">
            {getFormattedCurrency(values.amount)}
          </p>
          <p className="my-0 text-md title">
            {dayjs(values.date).format("MMM D")}
          </p>
        </Row>
      </Col>

      <Col span={1}>
        <Row className="h-100">
          <RightOutlined className="text-sm title" />
        </Row>
      </Col>
    </>
  );
};
